import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "language-dropdown" }
const _hoisted_2 = ["onClick"]

import { ref, onMounted, reactive, onBeforeUnmount } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Translator',
  setup(__props) {

const lang = ref(localStorage.getItem("lang"));
const languages = reactive([
  {
    name: "RUS",
    code: "ru",
    // flag: "🇷🇺",
  },
  {
    name: "ENG",
    code: "en",
    // flag: "🇺🇸",
  },
  {
    name: "CHI",
    code: "zh-CN",
    // flag: "🇨🇳",
  },
]);

// Управление выпадающим меню
const isDropdownOpen = ref(false);

const selectorRef = ref<HTMLElement | null>(null);

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
  loadGoogleTranslateScript();
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

function handleClickOutside(event: MouseEvent) {
  if (!isDropdownOpen.value) return;

  const target = event.target as Node | null;
  if (!target || !selectorRef.value) return;

  if (!selectorRef.value.contains(target)) {
    isDropdownOpen.value = false;
  }
}

function loadGoogleTranslateScript() {
  const saved = localStorage.getItem("lang") || "ru";
  if (saved !== "ru") {
    // грузим скрипт переводчика только если не ru
    const script = document.createElement("script");
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.head.appendChild(script);
    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement(
        {
          layout: (window as any).google.translate.TranslateElement.InlineLayout
            .SIMPLE,
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };
  } else {
    // если ru — чистим всё, чтобы не переводило автоматически
    document.cookie =
      "googtrans=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
    window.location.hash = "";
  }
}

function changeLanguage(targetLang: string) {
  const baseLang = document.documentElement.lang || "ru"; // дефолт сайта

  localStorage.setItem("lang", targetLang);

  if (targetLang === baseLang) {
    // сбрасываем перевод → показываем сайт в исходном виде
    document.cookie =
      "googtrans=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
    document.cookie = `googtrans=/auto/${baseLang};path=/;`;
    window.location.hash = "";
    location.reload();
    return;
  }

  // иначе обычный перевод
  const cookieVal = `/${baseLang}/${targetLang}`;
  document.cookie = `googtrans=${cookieVal};path=/;`;
  document.cookie = `googtrans=${cookieVal};domain=${location.hostname};path=/;`;

  window.location.hash = `#googtrans(${baseLang}|${targetLang})`;
  location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "language-selector notranslate",
    ref_key: "selectorRef",
    ref: selectorRef
  }, [
    _createElementVNode("div", {
      class: "selected-language",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isDropdownOpen.value = !isDropdownOpen.value), ["stop"]))
    }, [
      _createElementVNode("span", null, _toDisplayString(languages.find((l) => l.code === lang.value)?.name || languages[0].name), 1)
    ]),
    _withDirectives(_createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages, (language) => {
        return (_openBlock(), _createElementBlock("li", {
          key: language.code,
          onClick: _withModifiers(($event: any) => (changeLanguage(language.code)), ["stop"]),
          class: _normalizeClass({ active: language.code === lang.value })
        }, [
          _createElementVNode("span", null, _toDisplayString(language.name), 1)
        ], 10, _hoisted_2))
      }), 128))
    ], 512), [
      [_vShow, isDropdownOpen.value]
    ])
  ], 512))
}
}

})